import {
  GET_RESULT,
  GET_RESULT_SUCCESS,
  GET_RESULT_FAILURE,
  SET_RESULT,
  CREATE_RESULT,
  CREATE_RESULT_SUCCESS,
  CREATE_RESULT_FAILURE,
  GET_RESULT_USER,
  GET_RESULT_USER_SUCCESS,
} from 'actionTypes';
import normalize, { userSchema } from 'schema';

export function getResult() {
  return {
    type: GET_RESULT,
    payload: {},
  };
}

export function getResultSuccess(response, userId) {
  return {
    type: GET_RESULT_SUCCESS,
    result: {
      ...response.payload,
      user: userId,
    },
  };
}

export function getResultFailure(result) {
  return {
    type: GET_RESULT_FAILURE,
    result: {
      ...result,
      status: 'unreachable',
    },
  };
}

export function setResult(resultUUID) {
  return {
    type: SET_RESULT,
    result: {
      uuid: resultUUID,
      status: 'ready',
    },
  };
}

export function createResult() {
  return {
    type: CREATE_RESULT,
  };
}

export function createResultSuccess(response, userId) {
  return {
    type: CREATE_RESULT_SUCCESS,
    result: {
      ...response.payload,
      user: userId,
    },
  };
}

export function createResultFailure(response) {
  return {
    type: CREATE_RESULT_FAILURE,
    ...response,
  };
}

export function getResultUser(resultUUID) {
  return {
    type: GET_RESULT_USER,
    resultUUID,
    endpointArgs: {
      resultUUID,
    },
  };
}

export function getResultUserSuccess(response, resultUUID) {
  return {
    type: GET_RESULT_USER_SUCCESS,
    normalizedData: normalize(response.payload, userSchema),
    resultUUID,
  };
}



// WEBPACK FOOTER //
// ./src/actions/resultActions.js